var _rect, _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgAndybot(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 64 64",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 3,
    y: 3,
    width: 58,
    height: 58,
    rx: 16,
    fill: "#FDDB44",
    stroke: "#184985",
    strokeWidth: 4
  })), _g || (_g = /*#__PURE__*/React.createElement("g", {
    stroke: "#184985",
    strokeWidth: 4,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 13,
    y: 19,
    width: 38,
    height: 30,
    rx: 7
  }), /*#__PURE__*/React.createElement("path", {
    d: "M32 12v7M26 12h12"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 24,
    cy: 33,
    r: 3,
    fill: "#184985"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 40,
    cy: 33,
    r: 3,
    fill: "#184985"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M24 42h16"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgAndybot);
export default __webpack_public_path__ + "static/media/andybot.196fcb91dbab1899d2139636a46db661.svg";
export { ForwardRef as ReactComponent };